import { MonitoredState } from '../../types/app/monitoredState.types';
import { api } from '../core/api';

export const monitoredStateGetList = (parentId: number) =>
  api.get<MonitoredState[]>(`MonitoredState/GetList?parentId=${parentId}`).then((res) => res.data);

export const getCount = (parentId?: number) =>
  api
    .get<number>(`MonitoredState/GetCount` + (parentId ? `?parentId=${parentId}` : ''))
    .then((res) => res.data);
